import Progress from 'easy-circular-progress';
import FileSaver from 'file-saver';
import moment from 'moment';
import { Inject } from 'vue-di-container';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Toaster } from '../../../Services/toast';
import { SenderType } from '../../../shared/Enums/SenderType';
import UserRoleService from '../../../shared/userService/UserRoleService';
import UserService from '../../../shared/userService/UserService';
import { AttachmentModel } from '../../AddRequest/AttachmentModel';
import DashboardService from '../../Dashboard/DashboardService';
import RejectReasonMultiSelect from '../../RejectionReason/RejectReasonMultiSelect';
import { RejectionReasonModel } from '../../RejectionReason/RejectionReasonModel';
import {
    composeRejectionReason,
    otherRejectionReason,
    rejectionSelectionIsValid,
    senderNameRequestType,
} from '../../RejectionReason/rejectionReasonSelection';
import { SenderModel } from '../SenderModel';
import WithRender from './SenderInfo.html';
import SenderInfoService from './SenderInfoService';
import { SenderRequestApprovalHistoryViewModel } from './SenderRequestApprovalHistoryViewModel';
import { SenderRequestExtendViewModel } from './SenderRequestExtendViewModel';
import { AiView } from './AiViewModel';

@WithRender
@Component({
    components: {
        Progress,
        RejectReasonMultiSelect,
    }, diProvide: [
        DashboardService,
        UserService,
        SenderInfoService,
        UserRoleService,
    ],
})
export default class SenderInfo extends Vue {
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    @Prop({ type: Boolean, default: false })
    public isFromDashboard: boolean | any;
    @Prop({ type: String, default: '' })
    public id: string | any;
    public tenantId: string | any;
    public resendComment: string = '';
    public selectedRejectReasons: RejectionReasonModel[] = [];
    public otherRejectReasonText: string = '';
    @Inject(DashboardService) public dashboardService!: DashboardService;
    @Inject(SenderInfoService) public senderInfoService!: SenderInfoService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    public sender: SenderModel = {
        id: '',
        displayId: '',
        duration: '',
        senderType: 0,
        newSenderType: 0,
        senderStatus: 0,
        senderId: '',
        startDate: '',
        clientName: '',
        crNumber: '',
        enterpriseUnifiedNumber: '',
        providerName: '',
        customerType: 0,
        representativeEmail: '',
        representativeMobile: '',
        representativeName: '',
        senderRequestAttachments: [],
        senderName: '',
        requestStatus: 0,
        isAlreadyExist: false,
        lastRejectionReason: '',
        remainingDays: 0,
        totalDays: 0,
        comment: '',
        isScamSender: false,
        matchingScamSenderNames: [],
        isCriticalSender: false,
        tenantId: '',
        expiryDate: '',
        annualReferenceDate: '',
        verificationType: 0,
        crExpiryDate: '',
        companyName: '',
        representativeID: '',
        tenant: '',
        isAutoSuggested:false
    };
    public providerLocked: boolean = false;
    public providerExpired: boolean = false;
    public deleteDialog: boolean = false;
    public rejectdialog: boolean = false;
    public showSenderRequestTransactionsdialog: boolean = false;
    public showExtendRequestsdialog: boolean = false;
    public senderActivityHistoryLoading: boolean = false;
    public senderActivityHistoryError: boolean = false;
    public senderActivityHistoryLoaded: boolean = false;
    public deactivateDialog: boolean = false;
    public approveDialog: boolean = false;
    public finalApproveDialog: boolean = false;
    public resendDialog: boolean = false;
    public senderType: SenderType[] = [];
    public SenderRequestTransactions: SenderRequestApprovalHistoryViewModel[] = [];
    public senderRequestExtendViewModel: SenderRequestExtendViewModel[] = [];
    public selectedIds: string[] = [];
    public userRole: any;
    public customerType: string = '';
    public approveComment: string = '';
    public deleteComment: string = '';
    public User: any;
    public rules: Array<(v: any) => true | string> = [];
    public popUpRejectionReasons: RejectionReasonModel[] = [];
    public headers: any = [
        { text: this.$t('senderInfo.status'), value: 'requestStatus', align: 'center', sortable: false },
        { text: this.$t('senderInfo.dateTime'), value: 'createdDate', align: 'center', sortable: false },
        { text: this.$t('senderInfo.processedBy'), value: 'processedBy', align: 'center', sortable: false },
        { text: this.$t('senderInfo.comment'), value: 'comment', align: 'center', sortable: false },
    ];
    public legacyHeaders: any = [
        { text: this.$t('senderInfo.requestStatus'), value: 'requestStatus', align: 'center', sortable: false },
        { text: this.$t('senderInfo.createdDate'), value: 'createdDate', align: 'center', sortable: false },
        { text: this.$t('senderInfo.comment'), value: 'comment', align: 'center', sortable: false },
    ];
    public extendRequestHeaders: any = [
        { text: this.$t('senderInfo.extendRequestId'), value: 'extendRequestId', align: 'center', sortable: false },
        { text: this.$t('senderInfo.duration'), value: 'duration', align: 'center', sortable: false },
        { text: this.$t('senderInfo.requestStatus'), value: 'requestStatus', align: 'center', sortable: false },
        { text: this.$t('senderInfo.createdDate'), value: 'createdDate', align: 'center', sortable: false },
    ];
    public hasAIReview: boolean = false;
    public invalidAttachmentNote: string | null = null;
    public aiFailed: boolean = false;
    public showRecheck: boolean = false;
    public recheckBusy: boolean = false;
    public showScamListWarning: boolean = false;
    public scamListWarningText: string = '';
    public scamListWarningHtml: string = '';

    public async mounted() {
        this.selectedIds.push(this.id);
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);
        this.tenantId = this.User.details.TenantId;
        this.isFromDashboard = true;
        await this.loadSenderDetails();
        if (this.userRole === 2 || this.userRole === 5) {
            this.isProviderLocked();
        }
        if (this.userRole === 1 || this.userRole === 9 || this.userRole === 15) {
            await this.getRejectionReasons();
        }
        if (this.canAttemptAIReview) {
            await this.loadAIReview();
        }
    }

    private async loadSenderDetails(): Promise<void> {
        const details = await this.senderInfoService.GetById(this.id);
        if (!details) {
            return;
        }
        this.assignSenderFromApi(details);
        this.userRole = this.GetUserRole();
        this.customerType = this.getCustomerTypeText(this.sender.customerType);
        this.senderType = [];
        this.getSenderType();
        this.refreshScamListWarning();
    }

    private assignSenderFromApi(data: any): void {
        const matchingNames = data.matchingScamSenderNames || data.MatchingScamSenderNames || [];
        this.sender = {
            ...this.sender,
            ...data,
            matchingScamSenderNames: Array.isArray(matchingNames) ? matchingNames : [],
        };
    }

    private getMatchingScamSenderNames(): string[] {
        const names = this.sender.matchingScamSenderNames || [];
        return Array.isArray(names) ? names.filter((n) => !!n) : [];
    }

    private hasScamListRole(): boolean {
        return [1, 3, 4, 9].includes(Number(this.userRole));
    }

    private isPendingSenderRequest(): boolean {
        const status = Number(this.sender.requestStatus);
        return status === 1 || status === 10;
    }

    private refreshScamListWarning(): void {
        if (!this.hasScamListRole() || !this.isPendingSenderRequest()) {
            this.showScamListWarning = false;
            this.scamListWarningText = '';
            this.scamListWarningHtml = '';
            return;
        }

        const names = this.getMatchingScamSenderNames();
        if (names.length > 0) {
            this.showScamListWarning = true;
            const quotedNames = names.map((n) =>  this.escapeHtml(n)  ).join(', ');
            const namesBlock = '<span style="color: black;">[ ' + quotedNames + ' ]</span>';
            this.scamListWarningText = this.$t('shared.scamListSenderWarning', { names: '[ ' + names.map((n) =>  n ).join(', ') + ' ]' }).toString();
            this.scamListWarningHtml = this.$t('shared.scamListSenderWarning', { names: namesBlock }).toString();
            return;
        }

        if (this.sender.isScamSender) {
            this.showScamListWarning = true;
            this.scamListWarningText = this.$t('shared.senderWarning').toString();
            this.scamListWarningHtml = this.escapeHtml(this.scamListWarningText);
            return;
        }

        this.showScamListWarning = false;
        this.scamListWarningText = '';
        this.scamListWarningHtml = '';
    }

    private escapeHtml(value: string): string {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    private parsePayloadToView(payload: any): AiView {
        if (payload && Array.isArray(payload.fields)) {
            return this.parseReviewPayloadToView(payload);
        }
        const out: AiView = {
            rows: [],
            stamps: { chamberStamp: false, delegationLetterStamp: false, entityStamp: false },
            invalidNote: null,
            hasAIReview: false
        };
        const asBool = (v: any) => this.asBoolLoose(v);
        const display = (val: any): string => {
            if (typeof val === 'string') return val;
            if (Array.isArray(val)) {
                return val.map((x: any) =>
                    (x && typeof x === 'object' && (x as any).original) ? String(x.original) : String(x)
                ).join(', ');
            }
            if (val && typeof val === 'object' && (val as any).hasOwnProperty('original')) {
                return String((val as any).original || '');
            }
            return val != null ? String(val) : '';
        };

        const addRow = (fieldKey: string, providerInput: any, aiResult: any, status: number, sourceSection?: any) => {
            const label = this.mapAIFieldLabel(fieldKey) || this.labelMap[fieldKey] || fieldKey;
            if (!label) return;
            out.rows.push({ fieldKey, fieldName: label, providerInput, aiResult, status, sourceSection });
        };

        const takeProvider = (field: string): any => {
            switch (field) {
                case 'entity_name': return this.sender.clientName || '';
                case 'expiry_date': return this.sender.expiryDate || '';
                case 'authorized_name_to_use': return this.sender.representativeName || '';
                case 'authorized_mobile_to_use': return this.sender.representativeMobile || '';
                case 'authorized_email_to_use': return this.sender.representativeEmail || '';
                case 'authorized_id': return this.sender.representativeID || '';
                case 'brand_name': return (this.sender && this.sender.trademarkName) || '';
                case 'auth_number': return this.sender.crNumber || '';
                case 'enterprise_unified_number': return this.sender.enterpriseUnifiedNumber || '';
                case 'sender_id': return this.sender.senderName || '';
                case 'start_protection': return this.sender.protectionDateFrom || '';
                case 'end_protection': return this.sender.protectionDateTo || '';
                default: return '';
            }
        };

        if (payload && payload.stamps && typeof payload.stamps === 'object') {
            out.stamps = {
                chamberStamp: this.asBoolLoose(payload.stamps.chamberStamp),
                delegationLetterStamp: this.asBoolLoose(payload.stamps.delegationLetterStamp),
                entityStamp: this.asBoolLoose(payload.stamps.entityStamp),
            };
        } else {
            const av = (payload && payload.authorization_validation) || {};
            const isPrivate = (this.sender.customerType === 3);
            out.stamps = {
                delegationLetterStamp: asBool(av['has_authorization_letter']),
                entityStamp: asBool(av['has_establishment_stamp']),
                chamberStamp: isPrivate ? asBool(av['has_chamber_commerce_stamp']) : false
            };
        }

        const sections = [
            'authorization_validation',
            'commercial_registration_validation',
            'hrsd_license_validation',
            'intellectual_property_validation',
            'domain_validation'
        ];
        for (let i = 0; i < sections.length; i++) {
            const s = sections[i];
            const sec = payload && payload[s];
            if (sec && asBool(sec.valid_document) === false) {
                out.invalidNote = this.$t('shared.invalidAttachmentNoteAdmin').toString();
                break;
            }
        }

        const isGov = this.sender.customerType === 1;
        const isCharity = this.sender.customerType === 2;
        const baseGov = ['auth_number', 'entity_name', 'expiry_date', 'authorized_name_to_use', 'authorized_mobile_to_use', 'authorized_email_to_use'];
        const baseCharity = ['auth_number', 'enterprise_unified_number', 'entity_name', 'expiry_date', 'authorized_name_to_use', 'authorized_mobile_to_use', 'authorized_email_to_use'];
        const basePrivate = ['enterprise_unified_number', 'entity_name', 'expiry_date', 'authorized_name_to_use', 'authorized_mobile_to_use', 'authorized_email_to_use'];
        if (this.sender.customerType === 3 && this.sender.verificationType === 1) basePrivate.push('authorized_id');

        const allowedKeys = isGov ? baseGov : (isCharity ? baseCharity : (this.sender.customerType === 3 ? basePrivate : []));
        const ensureKeyInAnySection = (k: string) => {
            for (const secName of sections) {
                const sec = payload && payload[secName];
                if (!sec) continue;
                const inList = (arr?: any[]) => Array.isArray(arr) && arr.some(x => x && x.field === k);
                if (inList(sec.mismatched) || inList(sec.matched) || inList(sec.missing)) {
                    if (!allowedKeys.includes(k)) allowedKeys.push(k);
                    return;
                }
            }
        };
        ['brand_name', 'start_protection', 'end_protection'].forEach(ensureKeyInAnySection);

        const sectionToCandidates = (secName: string, secObj: any) => {
            const list: Array<{ fieldKey: string; providerInput: any; aiResult: any; status: number; src: string }> = [];
            if (!secObj) return list;
            const push = (arr: any[], status: number) => {
                if (!Array.isArray(arr)) return;
                for (let i = 0; i < arr.length; i++) {
                    const f = arr[i];
                    if (!f || !f.field) continue;
                    list.push({
                        fieldKey: String(f.field),
                        providerInput: Object.prototype.hasOwnProperty.call(f, 'user') ? f.user : null,
                        aiResult: f.extracted,
                        status,
                        src: secName
                    });
                }
            };
            push(secObj.matched, 0);
            push(secObj.mismatched, 1);
            push(secObj.missing, 2);
            return list;
        };

        const allCandidates: Array<{ fieldKey: string; providerInput: any; aiResult: any; status: number; src: string }> = [];
        for (let i = 0; i < sections.length; i++) {
            const n = sections[i];
            const c = sectionToCandidates(n, payload && payload[n]);
            for (let j = 0; j < c.length; j++) allCandidates.push(c[j]);
        }

        const statusScore = (s: number) => (s === 0 ? 2 : s === 1 ? 1 : 0);
        const sourceScore = (src: string) => (src === 'authorization_validation' ? 1 : 0);

        const bestByKey = new Map<string, typeof allCandidates[number]>();
        for (let i = 0; i < allCandidates.length; i++) {
            const c = allCandidates[i];
            if (allowedKeys.indexOf(c.fieldKey) === -1) continue;
            const prev = bestByKey.get(c.fieldKey);
            if (!prev) { bestByKey.set(c.fieldKey, c); continue; }
            const prevScore = statusScore(prev.status) + sourceScore(prev.src);
            const curScore = statusScore(c.status) + sourceScore(c.src);
            if (curScore > prevScore) bestByKey.set(c.fieldKey, c);
        }

        for (const [key, picked] of bestByKey.entries()) {
            const aiRaw = display(picked.aiResult);
            const fromProviderRaw = picked.providerInput != null ? picked.providerInput : takeProvider(key);
            const isDateKey = key === 'expiry_date' || key === 'start_protection' || key === 'end_protection';

            addRow(
                key,
                isDateKey ? this.normalizeDateDisplay(fromProviderRaw) : fromProviderRaw,
                isDateKey ? this.normalizeDateDisplay(aiRaw) : aiRaw,
                picked.status,
                picked.src ? ((k: string, root: any) => (root && root[k]) ? ({ [k]: root[k] }) : null)(picked.src, payload) : null
            );
        }

        out.hasAIReview = out.rows.length > 0 || out.stamps.delegationLetterStamp || out.stamps.entityStamp || out.stamps.chamberStamp;
        if (!out.invalidNote && this.hasInvalidUploadedDocument(payload, (payload && payload.fields) || [])) {
            out.invalidNote = this.$t('shared.invalidAttachmentNoteAdmin').toString();
        }
        return out;
    }

    public async loadAIReview() {
        this.aiReviewRows = [];
        this.aiStamps = null;
        this.hasAIReview = false;
        this.invalidAttachmentNote = null;
        this.aiFailed = false;
        this.showRecheck = false;
        try {
            const res: any = await this.senderInfoService.GetAIReviewResult(this.id);

            if (this.isAIUnavailablePayload(res)) {
                this.aiFailed = true;
                this.hasAIReview = false;

                const key = this.recheckKey();
                const alreadyClicked = sessionStorage.getItem(key) === '1';
                this.showRecheck = !alreadyClicked;
                return;
            }

            const parsed = this.parsePayloadToView(res);
            this.aiReviewRows = parsed.rows;
            this.aiStamps = parsed.stamps;
            this.hasAIReview = parsed.hasAIReview;
            this.invalidAttachmentNote = parsed.invalidNote || (parsed.hasAIReview ? this.$t('shared.invalidAttachmentNoteAdmin').toString() : null);
            this.aiFailed = false;
            this.showRecheck = false;
        } catch {
            this.aiReviewRows = [];
            this.aiStamps = { chamberStamp: false, delegationLetterStamp: false, entityStamp: false };
            this.hasAIReview = false;
            this.invalidAttachmentNote = null;
            this.aiFailed = true;
            const key = this.recheckKey();
            const alreadyClicked = sessionStorage.getItem(key) === '1';
            this.showRecheck = !alreadyClicked;
        }
    }

    public get rejectReasonsLocked(): boolean {
        return [2, 5].includes(this.userRole);
    }
    public onRejectReasonsChanged(value: RejectionReasonModel[]) {
        this.selectedRejectReasons = value ? value : [];
    }
    public onOtherRejectTextChanged(value: string) {
        this.otherRejectReasonText = value ? value : '';
    }
    public async isProviderLocked() {
        const response = await this.dashboardService.isProviderLocked();
        this.providerLocked = response.result;
    }
    public async isProviderExpired() {
        const response = await this.dashboardService.isProviderExpired();
        this.providerExpired = response.result;
    }
    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }
    public async getRejectionReasons() {
        const response = await this.dashboardService.getSenderNameRejectReasons(senderNameRequestType);
        this.popUpRejectionReasons = response && response.result ? response.result : [];
        this.popUpRejectionReasons.push(otherRejectionReason(
            senderNameRequestType,
            this.$t('dashboardPage.otherRejectionReason').toString()));
    }
    public formatProcessedBy(processedBy: string): string {
        if (processedBy === 'System') {
            return this.$t('senderInfo.system').toString();
        }
        return processedBy;
    }

    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }

    public getSenderType() {
        const senderBinary = this.sender.senderType;
        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }
    public activeTab = 0;
    public aiReviewRows: Array<{ fieldKey: string; fieldName: string; providerInput: any; aiResult: any; status: number }> = [];
    public aiReviewHeaders: any = [
        { text: this.$t('shared.fieldName'), value: 'fieldName', align: 'center', sortable: false },
        { text: this.$t('shared.providerInput'), value: 'providerInput', align: 'center', sortable: false },
        { text: this.$t('shared.aiResult'), value: 'aiResult', align: 'center', sortable: false },
        { text: this.$t('shared.status'), value: 'status', align: 'center', sortable: false },
    ];
    public aiStamps: null | { chamberStamp: boolean, delegationLetterStamp: boolean, entityStamp: boolean } = null;

    public get stampList() {
        if (this.sender.customerType === 3) {
            return [
                { key: 'delegationLetterStamp', prop: 'delegationLetterStamp' },
                { key: 'entityStamp', prop: 'entityStamp' },
                { key: 'chamberStamp', prop: 'chamberStamp' },
            ];
        }
        return [
            { key: 'delegationLetterStamp', prop: 'delegationLetterStamp' },
            { key: 'entityStamp', prop: 'entityStamp' },
        ];
    }

    public aiStatusText(status: number): string {
        switch (status) {
            case 0: return this.$t('shared.matched').toString();
            case 1: return this.$t('shared.notMatched').toString();
            case 2: return this.$t('shared.missing').toString();
            default: return '-';
        }
    }

    public get labelMap(): { [key: string]: string } {
        const common = {
            domain_name: this.$t('shared.domainName').toString(),
            brand_name: this.$t('shared.trademarkName').toString(),
            start_protection: this.$t('shared.protectionDateFrom').toString(),
            end_protection: this.$t('shared.protectionDateTo').toString(),

            entity_name: 'Client Name',
            expiry_date: 'Expiry Date',
            authorized_name_to_use: 'Representative Name',
            authorized_mobile_to_use: 'Representative Phone',
            authorized_email_to_use: 'Representative Email',
            sender_id: 'Sender Name'
        };

        if (this.sender.customerType === 1) {
            return {
                ...common,
                auth_number: 'Budget Number',
            };
        }
        if (this.sender.customerType === 2) {
            return {
                ...common,
                auth_number: 'License Number',
                enterprise_unified_number: 'Unified Enterprise Number',
            };
        }
        if (this.sender.customerType === 3) {
            return {
                ...common,
                enterprise_unified_number: 'Unified Enterprise Number',
                authorized_id: 'Representative ID Number',
            };
        }
        return {
            ...common,
            auth_number: 'Registration Number',
        };
    }

    public mapAIFieldLabel(field: string) {
        if (field === 'authorized_id' && this.sender.verificationType !== 1) {
            return '';
        }
        return this.labelMap[field] || field;
    }

    public canDeactivateCurrentSender(): boolean {
        if (!this.sender) {
            return false;
        }
        if (this.userRole !== 3) {
            return false;
        }
        const rs =
            this.sender.requestStatus !== undefined && this.sender.requestStatus !== null
                ? String(this.sender.requestStatus)
                : '';
        return rs === '4' || rs === '5';
    }

    public showDeactivateDialog() {
        this.deactivateDialog = true;
    }

    public hideDeactivateDialog() {
        this.deactivateDialog = false;
    }

    public cancelDeactivateDialog() {
        this.deactivateDialog = false;
        this.$router.push({ name: 'Dashboard' });
    }
    public async deactivate(id: string) {
        const response = await this.dashboardService.deactivate(this.selectedIds);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.deactivateDialog = false;
            this.reload();
        } else {
            this.deactivateDialog = false;
            this.selectedIds = [];
            Toaster.success(this.$t('dashboardPage.deactivatedsuccessfully').toString());
            this.reload();
        }
    }
    public showDeleteDialog(id: string) {
        this.deleteDialog = true;
    }
    public hideDeleteDialog() {
        this.deleteDialog = false;
    }
    public async deleteSender() {
        let ids: string[] = [];
        const response = await this.dashboardService.delete(this.sender.id, this.deleteComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.deleteDialog = false;
            this.reload();
        } else {
            this.deleteDialog = false;
            this.dashboardService.deleteRequestEmail(this.selectedIds);
            this.selectedIds = [];
            Toaster.success(this.$t('shared.deleteSuccessfully').toString());
            this.reload();
        }
    }
    public async reload() {
        this.selectedIds.push(this.id);
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);
        if (this.userRole === 2 || this.userRole === 5) {
            this.isProviderLocked();
        }
        this.isFromDashboard = true;
        this.tenantId = this.User.details.TenantId;
        await this.loadSenderDetails();
    }
    public checkColor(typeStatus: number) {
        switch (typeStatus) {
            case 1: {
                return '#c427ba';
                break;
            }
            case 2: {
                return '#5aaa0b';
                break;
            }
            case 3: {
                return '#C42727';
                break;
            }
            case 4: {
                return '#aaa7a7';
                break;
            }
            case 5: {
                return '#014bb1';
                break;
            }
            case 6: {
                return '#F78500';
                break;
            }
            case 7: {
                return '#5c9bf2';
                break;
            }
            case 10: {
                return '#9b2a5a';
                break;
            }
            case 11: {
                return '#421984';
                break;
            }
        }
    }
    public GetSenderStatus(typeStatus: number) {
        switch (typeStatus) {
            case 1: {
                return 'Pending Approval';
                break;
            }
            case 2: {
                return 'Approved';
                break;
            }
            case 3: {
                return 'Rejected';
                break;
            }
            case 4: {
                return 'Paid';
                break;
            }
            case 5: {
                return 'Expired';
                break;
            }
            case 6: {
                return 'Deleted';
                break;
            }
            case 9: {
                return 'Pending For Verify';
                break;
            }
            case 10: {
                return 'Pending For Review';
                break;
            }
            case 11: {
                return 'Deactivated';
                break;
            }
        }
    }

    public getRate(startDate: string, duration: string) {
        return (this.remainingDays(startDate, duration) / (parseInt(duration, 10) * 365)) * 100;
    }

    public remainingDays(startDate: string, duration: string): number {
        const todaysdate = moment();
        const expiryDate = moment(startDate).add(parseInt(duration, 10), 'years').calendar();
        const eventdate = moment(expiryDate);
        if (moment(moment(startDate).format('L')).isAfter(moment().format('L'))) {
            return eventdate.diff(moment(startDate), 'days') + 1;
        } else {
            return eventdate.diff(todaysdate, 'days') + 1;
        }
    }

    public expiryDate(startDate: string, duration: string): number {
        const expiryDateString = moment(startDate).add(parseInt(duration, 10), 'years').calendar();
        const eventdate = moment(startDate);
        const expiryDate = moment(expiryDateString);
        return expiryDate.diff(eventdate, 'days') + 1;
    }
    public showresendDialog() {
        this.resendDialog = true;
    }
    public hideresendDialog() {
        this.resendComment = '';
        this.resendDialog = false;
    }
    public showapproveDialog() {
        this.approveComment = '';
        this.approveDialog = true;
    }
    public hideapproveDialog() {
        this.approveDialog = false;
    }
    public showFinalApproveDialog() {
        this.finalApproveDialog = true;
    }
    public hideFinalApproveDialog() {
        this.finalApproveDialog = false;
    }
    public async approve() {
        if (this.sender.requestStatus !== 1) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
            return;
        }
        if (this.requiresSupportingDocumentBeforeDecision()) {
            Toaster.error(this.$t('shared.supportingDocumentRequired').toString());
            return;
        }
        const response = await this.dashboardService.approve(this.selectedIds, this.approveComment);
        if (response && response.isSuccess === false) {
            Toaster.error(response.errorMessage
                ? response.errorMessage
                : this.$t('shared.supportingDocumentRequired').toString());
            return;
        }
        Toaster.success(this.$t('dashboardPage.Approvedsuccessfully').toString());
        this.$router.go(0);
    }
    public async finalApprove() {
        if (this.sender.requestStatus !== 10) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
            return;
        } else {
            await this.dashboardService.finalApprove(this.selectedIds, this.approveComment);
            Toaster.success(this.$t('shared.finalApprovedsuccessfully').toString());
            await this.dashboardService.sendrApproveEmail(this.selectedIds);
            this.$router.go(0);
        }
    }
    public async resend() {
        if (this.sender.requestStatus !== 3) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderRejected').toString());
            return;
        }
        const response = await this.dashboardService.resend(this.selectedIds, this.resendComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            return;
        }
        Toaster.success(this.$t('dashboardPage.resentSuccessfully').toString());
        this.$router.go(0);
    }

    public ConectivityDetail(senderId: string) {
        this.$router.push({ name: 'SenderConectivityDetail', params: { senderId } });
    }
    public get rejectReasonIsValid(): boolean {
        return rejectionSelectionIsValid(this.selectedRejectReasons, this.otherRejectReasonText);
    }
    public async showRejectDialog() {
        this.rejectdialog = true;
    }
    public async hideRejectDialog() {
        this.selectedRejectReasons = [];
        this.otherRejectReasonText = '';
        this.rejectdialog = false;
    }
    public async reject() {
        if (this.sender.requestStatus !== 1 && this.sender.requestStatus !== 10) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderCanBeRejected').toString());
            return;
        }
        if (this.requiresSupportingDocumentBeforeDecision()) {
            Toaster.error(this.$t('shared.supportingDocumentRequired').toString());
            return;
        }
        const reason = composeRejectionReason(this.selectedRejectReasons, this.otherRejectReasonText);
        if (!this.rejectReasonIsValid || reason === '') {
            return;
        }
        this.rejectdialog = false;
        const response = await this.dashboardService.reject(this.selectedIds, reason);
        if (response && response.isSuccess === false) {
            Toaster.error(response.errorMessage
                ? response.errorMessage
                : this.$t('dashboardPage.NotAllSenderCanBeRejected').toString());
            return;
        }
        await this.dashboardService.rejectRequestEmail(this.selectedIds);
        this.selectedRejectReasons = [];
        this.otherRejectReasonText = '';
        this.selectedIds = [];
        Toaster.success(this.$t('dashboardPage.Rejectedsuccessfully').toString());
        this.$router.go(0);
    }
    public async showSenderRequestTransactions() {
        if (this.userRole === 3 || this.userRole === 4) {
            this.showSenderRequestTransactionsdialog = true;
            this.senderActivityHistoryLoading = true;
            this.senderActivityHistoryError = false;
            this.senderActivityHistoryLoaded = false;
            this.SenderRequestTransactions = [];

            var response = await this.senderInfoService.GetRequestApprovalHistory(this.id);
            this.senderActivityHistoryLoading = false;
            this.senderActivityHistoryLoaded = true;

            if (!response || response.isSuccess === false) {
                this.senderActivityHistoryError = true;
                return;
            }

            this.SenderRequestTransactions = response.result || [];
            return;
        }

        var legacyResponse = await this.senderInfoService.GetRequestApprovalHistory(this.id);
        if (legacyResponse && legacyResponse.isSuccess) {
            this.SenderRequestTransactions = legacyResponse.result;
            this.showSenderRequestTransactionsdialog = true;
        }
    }
    public async showExtendRequests() {
        var response = await this.senderInfoService.getExtendRequestsHistory(this.id);
        if (response.isSuccess) {
            this.senderRequestExtendViewModel = response.result;
            this.showExtendRequestsdialog = true;
        }
    }
    public async hideshowSenderRequestTransactionsdialog() {
        this.showSenderRequestTransactionsdialog = false;
        this.senderActivityHistoryLoading = false;
        this.senderActivityHistoryError = false;
        this.senderActivityHistoryLoaded = false;
        this.SenderRequestTransactions = [];
    }
    public async hideExtendRequestsdialog() {
        this.showExtendRequestsdialog = false;
    }
    public PreparePay() {
        if (this.sender.requestStatus !== 2) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderPendingPay').toString());
            return;
        } else {
            this.$router.push({ name: 'Payment', params: { ids: this.selectedIds.join(',') } });
        }
    }
    public async DownloadFile(file: AttachmentModel) {
        const fileContent = await this.senderInfoService.GetFileContent(file.id);
        const array = Buffer.from(fileContent, 'base64');
        const blob = new Blob([array], { type: 'application/pdf' });
        FileSaver.saveAs(blob, file.fileName);
    }

    public supportingDocumentFileName: string = '';
    public supportingDocumentFileContent: string = '';
    public supportingDocumentUploading: boolean = false;

    get showPreviousGovernmentSection(): boolean {
        const role = Number(this.userRole);
        return this.sender.isPreviouslyGovernmentOwned === true
            && (role === 1 || role === 9 || role === 15 || role === 3);
    }

    get canUploadSupportingDocument(): boolean {
        return this.showPreviousGovernmentSection
            && Number(this.sender.requestStatus) === 1
            && !this.sender.supportingDocumentAttachmentId;
    }

    get canDownloadSupportingDocument(): boolean {
        return this.showPreviousGovernmentSection
            && !!this.sender.supportingDocumentAttachmentId
            && !!this.sender.supportingDocumentFileName;
    }

    public requiresSupportingDocumentBeforeDecision(): boolean {
        const role = Number(this.userRole);
        if (role !== 1 && role !== 9 && role !== 15) {
            return false;
        }
        return this.sender.isPreviouslyGovernmentOwned === true
            && !this.sender.supportingDocumentAttachmentId;
    }

    get supportingDocumentReady(): boolean {
        return !!this.supportingDocumentFileName && !!this.supportingDocumentFileContent;
    }

    public onSupportingDocumentPicked(event: any): void {
        const files = event && event.target ? event.target.files : null;
        if (!files || files.length === 0) {
            this.supportingDocumentFileName = '';
            this.supportingDocumentFileContent = '';
            return;
        }
        const file = files[0];
        if (file.size > 3000000) {
            Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
            this.supportingDocumentFileName = '';
            this.supportingDocumentFileContent = '';
            return;
        }
        const reader = new FileReader();
        reader.onloadend = (fileData: any) => {
            if (!fileData || !fileData.target || !fileData.target.result) {
                this.supportingDocumentFileName = '';
                this.supportingDocumentFileContent = '';
                return;
            }
            const result = fileData.target.result as string;
            const parts = result.split(',');
            this.supportingDocumentFileContent = parts.length > 1 ? parts[1] : '';
            this.supportingDocumentFileName = file.name;
            this.uploadSupportingDocument();
        };
        reader.readAsDataURL(file);
    }

    public triggerSupportingDocumentPick(refName: string): void {
        const input = this.$refs[refName] as HTMLInputElement;
        if (input) {
            input.value = '';
            input.click();
        }
    }

    public async uploadSupportingDocument(): Promise<void> {
        if (!this.supportingDocumentReady || this.supportingDocumentUploading) {
            return;
        }
        this.supportingDocumentUploading = true;
        try {
            const response = await this.senderInfoService.UploadSupportingDocument(
                this.id,
                this.supportingDocumentFileName,
                this.supportingDocumentFileContent);
            if (response && response.isSuccess === true) {
                Toaster.success(this.$t('shared.supportingDocumentUploadedSuccessfully').toString());
                this.supportingDocumentFileName = '';
                this.supportingDocumentFileContent = '';
                await this.loadSenderDetails();
            } else {
                const message = response && response.errorMessage
                    ? response.errorMessage
                    : this.$t('shared.errorOccurred').toString();
                Toaster.error(message);
            }
        } finally {
            this.supportingDocumentUploading = false;
        }
    }

    public async downloadSupportingDocument(): Promise<void> {
        if (!this.canDownloadSupportingDocument) {
            return;
        }
        await this.DownloadFile({
            id: this.sender.supportingDocumentAttachmentId as string,
            fileName: this.sender.supportingDocumentFileName as string,
            file: null,
            fileContent: '',
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        });
    }

     get maskedRepresentativeName(): string {
          // 'Platform Admin'=1 'Super Admin'= 9 'Managing Requests'=15
     let isAdmin=this.userRole === 1|| this.userRole === 9 || this.userRole ===15

        if (!isAdmin && this.sender.verificationType === 1) 
            return this.getMaskedManagerName(this.sender.representativeName);
        return this.sender.representativeName;
    }

    getMaskedManagerName(fullName: string): string {
        if (!fullName) return '';
        const honorifics = [
            "السيد", "سيد", "السيدة", "سيده", "السيده", "سيدة",
            "Mr", "Mrs", "Ms", "انسة", "أنسه", "أنسة", "انسه"
        ];

        const RLM = "\u200F";
        let parts = fullName.split(' ').filter(p => p);

        const prefixParts: string[] = [];
        while (parts.length && honorifics.some(h => this.pEquals(parts[0], h))) {
            prefixParts.push(parts.shift()!);
        }

        const firstName = parts[0] || '';
        const fatherName = parts[1] || '';
        const familyName = parts.length > 2 ? parts[parts.length - 1] : '';

        const maskedFather = fatherName
            ? fatherName[0] + (fatherName.length > 1 ? '*'.repeat(fatherName.length - 1) : '')
            : '';

        const maskedFamily = familyName
            ? familyName.slice(0, 2) + (familyName.length > 2 ? '*'.repeat(familyName.length - 2) + RLM : '')
            : '';

        return [
            ...prefixParts,
            firstName,
            maskedFather,
            maskedFamily
        ].filter(Boolean).join(' ');
    }

    pEquals(a: string, b: string): boolean {
        return a.replace(/[ةه]/g, "ه").toLowerCase() === b.replace(/[ةه]/g, "ه").toLowerCase();
    }

    get canAttemptAIReview() {
        return (
            (this.sender.requestStatus === 1 || this.sender.requestStatus === 10) &&
            (this.userRole === 1 || this.userRole === 9 || this.userRole === 15)
        );
    }

    get showTabs() {
        return (
            this.sender.customerType !== 4 &&
            this.canAttemptAIReview &&
            (this.hasAIReview || this.aiFailed || !!this.invalidAttachmentNote)
        );
    }

    private asBoolLoose(v: any): boolean {
        if (typeof v === 'boolean') return v;
        if (typeof v === 'number') return v !== 0;
        if (typeof v === 'string') {
            const s = v.trim().toLowerCase();
            return s === 'true' || s === '1' || s === 'yes';
        }
        return false;
    }

    private displayForField(key: string, val: any): string {
        const normalize = (v: any): string => {
            if (typeof v === 'string') {
                try { return normalize(JSON.parse(v)); } catch { return v; }
            }
            if (Array.isArray(v)) {
                return v
                    .map((x: any) => (x && typeof x === 'object' && (x as any).original) ? String(x.original) : String(x))
                    .join(key === 'brand_name' ? ' - ' : ' - ');
            }
            if (v && typeof v === 'object' && (v as any).hasOwnProperty('original')) {
                const o = (v as any).original;
                return o ? String(o) : JSON.stringify(v);
            }
            return v != null ? String(v) : '';
        };

        if (key === 'brand_name') {
            const s = normalize(val);
            return s.includes(' - ') ? s.replace(/\s*,\s*/g, ' - ') : s;
        }
        return normalize(val);
    }

    private extractDomainRow(res: any, allFields: any[]) {
        const label = this.$t('shared.domainName').toString();

        const direct = (allFields || []).find(f => f && String(f.fieldName) === 'domain_name');
        if (direct) {
            return {
                fieldKey: 'domain_name',
                fieldName: label,
                providerInput: (direct && direct.providerInput != null)
                    ? direct.providerInput
                    : ((this.sender.domainName)
                        ? this.sender.domainName
                        : null),
                aiResult: this.displayForField('domain_name', direct.aiResult),
                status: typeof direct.status === 'number' ? direct.status : 2,
                source: direct.source
            };
        }

        let extracted = '';
        const top = (res && (res.senderId || res.sender_id_validation || res.senderIDValidation)) || null;
        if (top && typeof top === 'object') {
            const blk = top.sender_id_validation ? top.sender_id_validation : top;
            if (blk && blk.domain_name) extracted = String(blk.domain_name);
        }

        if (!extracted) {
            const senderRows = (allFields || []).filter(f => f && String(f.fieldName) === 'sender_id' && f.source);
            for (let i = 0; i < senderRows.length && !extracted; i++) {
                try {
                    const obj = typeof senderRows[i].source === 'string' ? JSON.parse(senderRows[i].source) : senderRows[i].source;
                    const blk = obj && (obj.sender_id_validation ? obj.sender_id_validation : obj);
                    if (blk && blk.domain_name) extracted = String(blk.domain_name);
                } catch { }
            }
        }

        if (!extracted) return null;

        const provider = (this.sender.domainName) || '';
        const matched = provider && extracted
            ? provider.toLowerCase().trim() === extracted.toLowerCase().trim()
            : false;

        return {
            fieldKey: 'domain_name',
            fieldName: label,
            providerInput: provider || null,
            aiResult: extracted,
            status: extracted ? (matched ? 0 : (provider ? 1 : 2)) : 2,
            source: 'senderId(domain_name)'
        };
    }
    
    public statusColor(status: number) {
        if (status === 0) return 'green';
        if (status === 1) return 'red';
        return 'orange';
    }

    public statusIcon(status: number) {
        if (status === 0) return 'mdi-check-circle';
        if (status === 1) return 'mdi-close-circle';
        return 'mdi-alert-circle';
    }

    private hasInvalidUploadedDocument(res: any, allFields: any[] = []): boolean {
        const topSections = [
            'authorization_validation',
            'commercial_registration_validation',
            'hrsd_license_validation',
            'intellectual_property_validation',
            'domain_validation'
        ];

        for (let i = 0; i < topSections.length; i++) {
            const secName = topSections[i];
            const sec = res && res[secName];
            if (sec && this.isExplicitFalse(sec.valid_document)) return true;
        }

        for (let i = 0; i < allFields.length; i++) {
            const f = allFields[i];
            const raw = f && f.source ? f.source : null;
            if (!raw) continue;

            let obj: any = null;
            try {
                obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
            } catch {
                obj = null;
            }
            if (!obj || typeof obj !== 'object') continue;

            for (let j = 0; j < topSections.length; j++) {
                const name = topSections[j];
                const sec = obj[name] || obj; 
                if (sec && typeof sec === 'object' && this.isExplicitFalse(sec.valid_document)) {
                    return true;
                }
            }
        }
        return false;
    }

    private isExplicitFalse(val: any): boolean {
        if (typeof val === 'boolean') return val === false;
        if (typeof val === 'string') return val.trim().toLowerCase() === 'false';
        return false;
    }

    get aiFailedText(): string {
        return this.showRecheck
            ? 'AI service is currently unavailable to process the data, You can try again by clicking "Recheck".'
            : 'AI service is currently unavailable to process the data.';
    }

    private isAIUnavailablePayload(payload: any): boolean {
        if (!payload || typeof payload !== 'object') return true;

        if (Array.isArray(payload.fields) &&
            payload.fields.some((f: any) => f && String(f.fieldName) === '__AI_FAILED__')) {
            return true;
        }

        const msg = String((payload.message || payload.Message || '')).trim();
        if (msg.startsWith('InternalProcessingFailed')) return true;
        if (payload.ai_failed === true || payload.AI_Failed === true) return true;

        const sections = [
            'authorization_validation',
            'commercial_registration_validation',
            'hrsd_license_validation',
            'intellectual_property_validation',
            'domain_validation',
            'sender_id_validation'
        ];
        const hasAnySection = sections.some(s => payload && payload[s] && typeof payload[s] === 'object');
        if (hasAnySection) return false;

        const hasFields = Array.isArray(payload.fields) && payload.fields.length > 0;
        const hasStamps = !!(payload.stamps && (payload.stamps.delegationLetterStamp || payload.stamps.entityStamp || payload.stamps.chamberStamp));
        const hasSenderInfo = !!(payload.senderId || payload.sender_id_validation || payload.senderIDValidation);

        return !(hasFields || hasStamps || hasSenderInfo);
    }

    private buildAIDocFieldsFromReviewRows_ForAdmin(
        latestPayload: any,
        parsed: { rows: any[]; stamps: any }
    ) {
        const list: Array<{ fieldName: string; providerInput: string; aiResult: string; status: number; source: string }> = [];

        (parsed.rows || []).forEach((r: any) => {
            list.push({
                fieldName: r.fieldKey,
                providerInput: (r.providerInput != null ? String(r.providerInput) : ''),
                aiResult: (r.aiResult != null ? String(r.aiResult) : ''),
                status: typeof r.status === 'number' ? r.status : 2,
                source: JSON.stringify(r.sourceSection || {})
            });
        });

        const mustHaveKeys = ['brand_name', 'start_protection', 'end_protection'];
        const already = new Set(list.map(x => (x.fieldName || '').trim().toLowerCase()));

        const pushIfMissing = (fieldName: string, providerInput: any, aiResult: any, status: number, sourceObj: any) => {
            const k = (fieldName || '').trim().toLowerCase();
            if (already.has(k)) return;

            list.push({
                fieldName,
                providerInput: providerInput != null ? String(providerInput) : '',
                aiResult: aiResult != null ? String(aiResult) : '',
                status,
                source: JSON.stringify(sourceObj || {})
            });
            already.add(k);
        };

        const candidateSections = [
            'intellectual_property_validation',
            'authorization_validation',
            'commercial_registration_validation',
            'domain_validation',
            'hrsd_license_validation'
        ];

        const sections: any[] = [];
        candidateSections.forEach(sec => {
            const obj = latestPayload && latestPayload[sec];
            if (obj && typeof obj === 'object') sections.push({ name: sec, obj });
        });

        const takeFromSec = (secObj: any, field: string) => {
            const pick = (arr?: any[]) => {
                if (!Array.isArray(arr)) return undefined;
                const f = arr.find(x => x && String(x.field) === field);
                return f ? { user: f.user, extracted: f.extracted, status: arr === secObj.matched ? 0 : arr === secObj.mismatched ? 1 : 2 } : undefined;
            };
            return pick(secObj.matched) || pick(secObj.mismatched) || pick(secObj.missing);
        };

        mustHaveKeys.forEach((key) => {
            let filled = false;

            for (let i = 0; i < sections.length && !filled; i++) {
                const { name, obj } = sections[i];
                const hit = takeFromSec(obj, key);
                if (hit) {
                    const providerInput = (hit.user != null ? hit.user : '');
                    const aiResult = hit.extracted != null ? hit.extracted : '';
                    const normalizedProvider =
                        (key === 'start_protection' || key === 'end_protection') ? this.normalizeDateDisplay(providerInput) : providerInput;
                    const normalizedAI =
                        (key === 'start_protection' || key === 'end_protection') ? this.normalizeDateDisplay(aiResult) : aiResult;

                    pushIfMissing(
                        key,
                        normalizedProvider,
                        normalizedAI,
                        hit.status,
                        { [name]: obj }
                    );
                    filled = true;
                }
            }

            if (!filled && latestPayload && Array.isArray(latestPayload.fields)) {
                const f = latestPayload.fields.find((x: any) => String(x.fieldName || '').trim() === key);
                if (f) {
                    const isDate = key === 'start_protection' || key === 'end_protection';
                    pushIfMissing(
                        key,
                        isDate ? this.normalizeDateDisplay(f.providerInput) : f.providerInput,
                        isDate ? this.normalizeDateDisplay(f.aiResult) : f.aiResult,
                        typeof f.status === 'number' ? f.status : 2,
                        f.source || {}
                    );
                }
            }
        });

        const wrapAuth = (latestPayload && latestPayload.authorization_validation)
            ? { authorization_validation: latestPayload.authorization_validation }
            : {};

        const addStamp = (name: string, ok: boolean) => list.push({
            fieldName: name,
            providerInput: '',
            aiResult: ok ? 'true' : 'false',
            status: ok ? 0 : 1,
            source: JSON.stringify(wrapAuth || {})
        });

        addStamp('delegationLetterStamp', parsed.stamps.delegationLetterStamp);
        addStamp('entityStamp', parsed.stamps.entityStamp);
        if (this.sender.customerType === 3) {
            addStamp('chamberStamp', parsed.stamps.chamberStamp);
        }

        if (!list.length) {
            list.push({ fieldName: '__AI_FAILED__', providerInput: '', aiResult: 'AI Failed', status: 2, source: '{}' });
        }

        return list;
    }

    public async recheckAI() {
        if (this.recheckBusy) return;
        this.recheckBusy = true;
        const key = this.recheckKey();
        sessionStorage.setItem(key, '1');
        this.showRecheck = true;

        try {
            const payload = await this.senderInfoService.recheckAIById(this.id);

            if (this.isAIUnavailablePayload(payload)) {
                this.aiFailed = true;
                this.hasAIReview = false;
                this.aiReviewRows = [];
                this.aiStamps = { chamberStamp: false, delegationLetterStamp: false, entityStamp: false };
                this.invalidAttachmentNote = null;
                return;
            }

            const parsed = this.parsePayloadToView(payload);
            this.aiReviewRows = parsed.rows;
            this.aiStamps = parsed.stamps;
            this.hasAIReview = parsed.hasAIReview;
            this.invalidAttachmentNote = parsed.invalidNote || (parsed.hasAIReview ? this.$t('shared.invalidAttachmentNoteAdmin').toString() : null);
            this.aiFailed = false;

            const fields = this.buildAIDocFieldsFromReviewRows_ForAdmin(payload, parsed);
            await this.senderInfoService.saveAIResults(this.id, fields);
            Toaster.success(this.$t('shared.recheckDone').toString());
        } catch {
            this.aiFailed = true;
            this.hasAIReview = false;
            this.aiReviewRows = [];
            this.aiStamps = { chamberStamp: false, delegationLetterStamp: false, entityStamp: false };
            this.invalidAttachmentNote = null;
            Toaster.error(this.$t('shared.generalError').toString() || 'Failed to recheck');
        } finally {
            this.recheckBusy = false;
            this.showRecheck = false;
        }
    }

    private parseReviewPayloadToView(payload: any): AiView {
        const out: AiView = {
            rows: [],
            stamps: { chamberStamp: false, delegationLetterStamp: false, entityStamp: false },
            invalidNote: null,
            hasAIReview: false
        };

        const fields = (payload && Array.isArray(payload.fields)) ? payload.fields : [];

        for (let i = 0; i < fields.length; i++) {
            const f = fields[i];
            if (!f || typeof f !== 'object') continue;

            const name = String(f.fieldName || '').trim();
            const ai = (f.aiResult != null ? String(f.aiResult) : '');
            const status = typeof f.status === 'number' ? f.status : 2;

            if (name === 'delegationLetterStamp') { out.stamps.delegationLetterStamp = (ai === 'true'); continue; }
            if (name === 'entityStamp') { out.stamps.entityStamp = (ai === 'true'); continue; }
            if (name === 'chamberStamp') { out.stamps.chamberStamp = (ai === 'true'); continue; }

            const label = this.mapAIFieldLabel(name) || this.labelMap[name] || name;

            const providerRaw = (f.providerInput != null ? f.providerInput : '');
            const aiRaw = ai;
            const isDate = name === 'expiry_date' || name === 'start_protection' || name === 'end_protection';

            out.rows.push({
                fieldKey: name,
                fieldName: label,
                providerInput: isDate ? this.normalizeDateDisplay(providerRaw) : providerRaw,
                aiResult: isDate ? this.normalizeDateDisplay(aiRaw) : aiRaw,
                status,
                source: typeof f.source === 'string' ? f.source : JSON.stringify(f.source || {})
            });
        }

        if (payload && payload.stamps && typeof payload.stamps === 'object') {
            if (Object.prototype.hasOwnProperty.call(payload.stamps, 'delegationLetterStamp')) {
                out.stamps.delegationLetterStamp = this.asBoolLoose(payload.stamps.delegationLetterStamp);
            }
            if (Object.prototype.hasOwnProperty.call(payload.stamps, 'entityStamp')) {
                out.stamps.entityStamp = this.asBoolLoose(payload.stamps.entityStamp);
            }
            if (Object.prototype.hasOwnProperty.call(payload.stamps, 'chamberStamp')) {
                out.stamps.chamberStamp = this.asBoolLoose(payload.stamps.chamberStamp);
            }
        }

        out.hasAIReview =
            out.rows.length > 0 ||
            out.stamps.delegationLetterStamp ||
            out.stamps.entityStamp ||
            out.stamps.chamberStamp;

        const tryParse = (s: string) => { try { return JSON.parse(s); } catch { return null; } };
        for (let i = 0; i < fields.length; i++) {
            const src = typeof fields[i].source === 'string' ? tryParse(fields[i].source) : (fields[i].source || null);
            const cand = src && (
                src.authorization_validation ||
                src.commercial_registration_validation ||
                src.hrsd_license_validation ||
                src.intellectual_property_validation ||
                src.domain_validation
            );
            if (cand && (String(cand.valid_document).trim().toLowerCase() === 'false' || cand.valid_document === false)) {
                out.invalidNote = this.$t('shared.invalidAttachmentNoteAdmin').toString();
                break;
            }
        }
        if (!out.invalidNote && this.hasInvalidUploadedDocument(payload, fields)) {
            out.invalidNote = this.$t('shared.invalidAttachmentNoteAdmin').toString();
        }

        return out;
    }

    private recheckKey(): string {
        const userId = (this.User && (this.User.id || this.User.userId)) ? (this.User.id || this.User.userId) : 'anon';
        const sessionMarker = localStorage.getItem('session_expiry') || 'noexp';
        return `recheckShown:${userId}:${this.id}:${sessionMarker}`;
    }

    public onLogoutOrSessionEnd() {
        Object.keys(sessionStorage)
            .filter(k => k.startsWith('recheckShown:'))
            .forEach(k => sessionStorage.removeItem(k));
    }

    private formatGregorianYMD(d: Date): string {
        const y = d.getUTCFullYear();
        const m = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        return `${y}/${m}/${day}`;
    }

    private hijriUmmAlQuraToGregorian(hijri: string): string {
        if (!hijri) return '';
        const ascii = this.toAsciiDigits(hijri).trim();
        const m = ascii.match(/^(\d{3,4})[\/\-.](\d{1,2})[\/\-.](\d{1,2})$/);
        if (!m) return '';

        const targetY = m[1].padStart(4, '0');
        const targetM = m[2].padStart(2, '0');
        const targetD = m[3].padStart(2, '0');

        let fmtHijri: Intl.DateTimeFormat;
        try {
            fmtHijri = new Intl.DateTimeFormat('en-u-ca-islamic-umalqura', {
                timeZone: 'UTC',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        } catch {
            return '';
        }

        const dayMs = 24 * 60 * 60 * 1000;
        let t = Date.UTC(1937, 2, 14);     
        const end = Date.UTC(2077, 10, 16);

        for (; t <= end; t += dayMs) {
            const d = new Date(t);
            const parts = fmtHijri.formatToParts(d);
            let y = '', mo = '', da = '';
            for (let i = 0; i < parts.length; i++) {
                const p = parts[i];
                if (p.type === 'year') y = p.value;
                else if (p.type === 'month') mo = p.value;
                else if (p.type === 'day') da = p.value;
            }
            if (y === targetY && mo === targetM && da === targetD) {
                return this.formatGregorianYMD(d);
            }
        }
        return '';
    }

    private normalizeDateDisplay(v: any): string {
        if (!v) return '';
        const s = String(v).trim();
        const g = this.hijriUmmAlQuraToGregorian(s);
        if (g) return g;

        let m = moment.utc(s, [
            'YYYY/MM/DD', 'YYYY-M-D', 'YYYY-MM-DD',
            'DD/MM/YYYY', 'D/M/YYYY',
            'MM/DD/YYYY', 'M/D/YYYY'
        ], true);
        if (m.isValid()) return m.format('YYYY/MM/DD');
        return s;
    }

    private toAsciiDigits(s: string): string {
        return s.replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));
    }

  
    public async saveCriticalSender() {
        const response = await this.senderInfoService.saveCriticalSender(this.sender.id, this.sender.isCriticalSender);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.reload();
        } else {
            Toaster.success(this.$t('dashboardPage.criticalSenderSavedSuccessfully').toString());
            this.reload();
        }
    }


}
